import React, { useEffect, useState } from "react";
import { Empty } from 'antd';
import AccountTransactionListComponent from './AccountTransactionListComponent'
import RequestHandler from "../../../../util/RequestHandler";

const AccountPage = (props) => {
  const [accountsList, setAccountList] = useState([])
  const [dataState, setDataState] = useState([{ skip: 0, take: 5 }]);
  const [take, setTake] = useState(5);
  const [skip, setSkip] = useState(0);
  const [activeKey, setActiveKey] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    RequestHandler.get(`/AccountTransaction?$filter=Contains(debtOrCredit,'A') &$count=true&$skip=${skip}&$top=${take}`).then(response => {
      setAccountList(response.value);
    });
  }, [query, setDataState, skip, setSkip, setActiveKey]);

  const ContactSideBar = (value) => {
    return <AccountTransactionListComponent data={accountsList} isDigitHomePage={props.isDigitHomePage} />
  };
  return (
    <div>
      {
        accountsList.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" /> :
          ContactSideBar()
      }
    </div>
  )
}

export default AccountPage
